import { createMuiTheme } from '@material-ui/core/styles';
import {lightTheme} from '../../../../../../themes';
import { FontSizes } from '@fluentui/theme';
import { SharedColors } from '@fluentui/theme';

const theme = createMuiTheme();

const materialUI = ({
    table:{
      padding:theme.spacing(2)
    }
});

  
const fluentUI ={

      fileIconCell: {
        textAlign: 'left',
        selectors: {
          '&:before': {
            content: '.',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0px',
            visibility: 'hidden',
          },
        },
      },
      highlightRow:{
        backgroundColor: '#dff6dd',
        selectors:{
          '&:hover':{backgroundColor:lightTheme.palette.themeLighter}
        }
      },
      tableRow:{
        selectors:{
          '&:hover':{backgroundColor:lightTheme.palette.themeLighter}
        }
      },
      controlWrapper: {
        width:'100%'
      },
      search:{
        margin: '5px 5px 5px 5px',
      },
      tableWrapper:{
        height: '550px',
        position: 'relative',
        maxHeight: 'inherit'
      },
      newIcon:{
        color:SharedColors.yellowGreen10,
      },
      deleteIcon:{
        color:SharedColors.red10,
      },
      changesIcon:{
        color:SharedColors.orangeYellow10,
      },
}

const styles={
    materialUI,
    fluentUI
};


  export default styles;